export const formatPrice = (value) => {
  const normalized = `${value}`
    .replace(/\s/g, '')
    .replace(',', '.');

  const number = Number(normalized);
  if (Number.isNaN(number)) return '';

  const rounded = number.toFixed(2);

  const [integer, fraction] = `${rounded}`.split('.');
  const formatted = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

  return fraction
    ? `${formatted},${fraction}`
    : formatted;
};
